module.exports = __webpack_public_path__ + "img/right.8bfbb061.png";